import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal } from '@mui/material';
import { useModalRegistration } from '@stores/ModalStore';
import { ReactNode } from 'react';
import css from './NewLibraryModalBase.module.scss';

interface NewLibraryModalBaseProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export const NewLibraryModalBase = ({
  open,
  onClose,
  title = 'Your media library',
  children,
}: NewLibraryModalBaseProps) => {
  // Note: 'library-create' is intentionally shared with LibraryCreateModal so the drag-drop
  // overlay is suppressed while any library-creation modal is open.
  useModalRegistration('library-create', open);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="library-modal"
      aria-describedby="library-modal-description"
    >
      <Box className={css.modal}>
        <IconButton className={css.closeButton} onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
        <h2>{title}</h2>
        {children}
      </Box>
    </Modal>
  );
};
